<template>
  <div>
    <px-view-header title="Unidades de Medida" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-unidades-medida-list-header :on-click-refresh="onClickRefresh"
                                    :on-change-filter="onChangeFilter" />
    <px-unidades-medida-list :unidadesMedidas="unidadesMedidas"
                             :loading="loading"
                             :on-change-options="onChangeOptions"
                             :options-list="optionsList"
                             :footer-options="footerOptions"
                             @remove="onRemove" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-unidades-medida/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import UnidadesMedidaService from './unidades-medida-service';
import UnidadesMedidaList from './UnidadesMedidaList.vue';
import UnidadesMedidaListHeader from './UnidadesMedidaListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Produto' },
        { text: 'Unidades de Medida' },
      ],
      unidadesMedidas: {
        content: [],
        total: 0,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemUnidadesMedida', ['stringFilter', 'listOptions']),
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['idEntidade']),
  },
  methods: {
    ...mapActions('listagemUnidadesMedida', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getUnidadesMedida();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getUnidadesMedida();
    },
    onClickRefresh() {
      this.getUnidadesMedida();
    },
    onRemove(item) {
      this.loading = true;
      UnidadesMedidaService.remover(item.id)
        .then(() => {
          this.$toast('Unidade de medida removida com sucesso', { color: 'success' });
          this.getUnidadesMedida();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getUnidadesMedida() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return UnidadesMedidaService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.unidadesMedidas = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxUnidadesMedidaList: UnidadesMedidaList,
    pxUnidadesMedidaListHeader: UnidadesMedidaListHeader,
  },
};

</script>
